export default __webpack_public_path__ + "static/media/logo_fotter.07fdd596.svg";